export default __webpack_public_path__ + "static/media/Headshot.ce875d2a.JPG";